import styled from "styled-components";
import {GAME_PC_BUTTON_HEIGHT, GAME_PC_BUTTON_WIDTH} from "../../../../../game-css-constants";

export const GamePlayPcHeaderBarFullScreenButtonBox = styled.button<{isInFullScreen: boolean}>`
    background-image: url("${props => props.isInFullScreen 
                                ? props.theme.assets.images.full_screen_off_png.toString() 
                                : props.theme.assets.images.full_screen_on_png.toString()}");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    width: ${GAME_PC_BUTTON_WIDTH};
    height: ${GAME_PC_BUTTON_HEIGHT};

    &:hover {
      opacity: 0.5;
    }
`